<div [id]="htmlId()" class="section repeat-group-section" [style.display]="isVisible() ? 'flex' : 'none'">
  @if (!isReadonly() && form().enabled) {
    <div class="icon" (click)="onDeleteRepeatInstanceRequested($event)">
      <mat-icon>delete</mat-icon>
    </div>
  }
  <span class="title">{{ title() }}</span>
</div>
